var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h4',{staticClass:"card-title"},[_vm._t("title")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }